
import { Component, Vue } from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";
import {getBceidRegisterUrl} from "./BCeID_URLs";

import { namespace } from "vuex-class";   
import "@/store/modules/common";
import { documentTypesJsonInfoType } from '@/types/Common';
const commonState = namespace("Common");

@Component
export default class LandingPage extends Vue {

    @commonState.Action
    public UpdateDocumentTypesJson!: (newDocumentTypesJson: documentTypesJsonInfoType[]) => void
    
    isLoggedIn = false;
    pageReady = false;
    safetyInst = false;
      
    async mounted() {
        this.pageReady = false;
        this.safetyInst = false;
        await SessionManager.getUserInfo(this.$store);
        if(this.$store.state.Common.userId !== ""){
            this.isLoggedIn = true
            this.$router.push({ name: "applicant-status" });
        }else{
            this.isLoggedIn = false;
            this.pageReady = true;
        } 
        console.log('Welcome to FLAAP, version: '+ Vue.filter('get-current-version')())
    }
  
    public navigate(userType) {          

        if(userType == 'new'){
            window.location.replace(getBceidRegisterUrl());
        }else{
            this.$router.push({ name: "applicant-status" }); 
        }     
    }
  
}
